import CheckBoxGroup from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxGroup'
import CheckBoxInput from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxInput'
import CheckBoxLabel from '@pc/components/Works/Panel/shared/Checkbox/CheckBoxLabel'
import ControlGroup from '@pc/components/Works/Panel/shared/ControlGroup'
import MiscHeading from '@pc/components/Works/Panel/shared/Heading/MiscHeading'
import EmphasisSelectBox from '@pc/components/Works/Panel/shared/Selectbox/EmphasisSelectBox'
import type { SearchParamsAttributes, TimeSlot } from '@pc/components/Works/Panel/types'
import CheckBoxFeatureInputSet from './CheckBoxFeatureInputSet'
import FeatureBox from './FeatureBox'
import type { ChangeEvent } from 'react'

interface PropsType {
  timeSlots: TimeSlot[]
  selectedKeepUpDay: SearchParamsAttributes['keepup_day']
  selectedKeepUpHour: SearchParamsAttributes['keepup_hour']
  selectedTimeSlotIds: SearchParamsAttributes['time_slots']
  changeState: (arg: any) => void
}

const renderHourOptions = () => {
  const range = Array.from({ length: 6 }, (_, i) => i + 3)
  return range.map((hour) => {
    return (
      <option key={hour} value={hour}>
        {hour}時間
      </option>
    )
  })
}

const renderDayOptions = () => {
  const range = Array.from({ length: 5 }, (_, i) => i + 1)
  return range.map((day) => {
    return (
      <option key={day} value={day}>
        週{day}日からOK
      </option>
    )
  })
}

const renderTimeSlotCheckboxes = (
  timeSlots: TimeSlot[],
  selectedTimeSlotIds: SearchParamsAttributes['time_slots'],
  toggleCheckbox: (e: ChangeEvent<HTMLInputElement>) => void
) => {
  return timeSlots.map((timeSlot) => {
    const { id, attributes } = timeSlot
    const timeSlotsId = `timeSlots-${id}`
    return (
      <CheckBoxFeatureInputSet key={id}>
        <CheckBoxInput type="checkbox" id={timeSlotsId} value={id} onChange={toggleCheckbox} checked={selectedTimeSlotIds?.includes(id)} />
        <CheckBoxLabel htmlFor={timeSlotsId}>{attributes.name}</CheckBoxLabel>
      </CheckBoxFeatureInputSet>
    )
  })
}

const DateTimeBox = (props: PropsType) => {
  const { timeSlots, selectedTimeSlotIds, selectedKeepUpDay, selectedKeepUpHour, changeState } = props

  const changeSelectBoxOfKeepUpDay = (e: ChangeEvent<HTMLInputElement>) => {
    changeState({ selectedKeepUpDay: e.target.value })
  }

  const changeSelectBoxOfKeepUpHour = (e: ChangeEvent<HTMLInputElement>) => {
    changeState({ selectedKeepUpHour: e.target.value })
  }

  const toggleCheckbox = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target

    if (checked) {
      const concatedTimeSlotIds = selectedTimeSlotIds?.concat(value)
      changeState({ selectedTimeSlotIds: concatedTimeSlotIds })
    } else {
      const filteredTimeSlotIds = selectedTimeSlotIds?.filter((selectedTimeSlotId) => selectedTimeSlotId !== value)
      changeState({ selectedTimeSlotIds: filteredTimeSlotIds })
    }
  }

  return (
    <FeatureBox>
      <MiscHeading>働く日数・時間</MiscHeading>
      <div className="mt-2.5 flex gap-x-5">
        <EmphasisSelectBox className="bg-position-[right_10px_center] pr-8" value={selectedKeepUpDay} onChange={changeSelectBoxOfKeepUpDay}>
          <option value="" key={0}>
            週の勤務日数
          </option>
          {renderDayOptions()}
        </EmphasisSelectBox>
        <EmphasisSelectBox className="bg-position-[right_10px_center] pr-8" value={selectedKeepUpHour} onChange={changeSelectBoxOfKeepUpHour}>
          <option value="" key={0}>
            1日の勤務時間
          </option>
          {renderHourOptions()}
        </EmphasisSelectBox>
      </div>
      <ControlGroup>
        <CheckBoxGroup>{renderTimeSlotCheckboxes(timeSlots, selectedTimeSlotIds, toggleCheckbox)}</CheckBoxGroup>
      </ControlGroup>
    </FeatureBox>
  )
}

export default DateTimeBox
